import { render, staticRenderFns } from "./TaxStatusModal.vue?vue&type=template&id=55e72092&scoped=true"
import script from "./TaxStatusModal.vue?vue&type=script&lang=js"
export * from "./TaxStatusModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e72092",
  null
  
)

export default component.exports